// src/edition/EditionContext.js
import React, { createContext, useContext, useMemo, useEffect } from 'react';

const EditionContext = createContext({
  isDemo: false,
});

export const EditionProvider = ({ children }) => {
  const searchParams = new URLSearchParams(window.location.search);
  const editionFromUrl = searchParams.get('edition'); // 'demo' | 'full' | null
  const editionFromStorage = window.localStorage.getItem('edition'); // string | null

  let edition = 'full'; // default

  if (editionFromUrl === 'demo' || editionFromUrl === 'full') {
    // URL overrides everything
    edition = editionFromUrl;
  } else if (editionFromStorage === 'demo' || editionFromStorage === 'full') {
    // fallback to stored
    edition = editionFromStorage;
  }

  // Persist the chosen edition so it survives refresh / navigation
  useEffect(() => {
    window.localStorage.setItem('edition', edition);
  }, [edition]);

  const value = useMemo(
    () => ({
      isDemo: edition === 'demo',
    }),
    [edition]
  );

  return (
    <EditionContext.Provider value={value}>
      {children}
    </EditionContext.Provider>
  );
};

export const useEdition = () => useContext(EditionContext);
